import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import Slider from 'react-slick';
import parseContent from 'utils/formatNewlines';
import dayjs from 'dayjs';
import Cookies from 'js-cookie';

import Button from 'ui/Button';
import slidePrev from 'assets/slidePrev.svg';
import slideNext from 'assets/slideNext.svg';
import { devices } from 'styles/devices';

const cookiesKey = 'popupClosedAt';
const shouldShow = (closedByUser, posts) => {
   if (closedByUser) return false;
   if (!posts.length) return false;
   const popupClosedAtRaw = Cookies.get(cookiesKey);
   if (!popupClosedAtRaw) return true;
   const popupClosedAt = dayjs(popupClosedAtRaw);
   const foundPostModifiedAfterLastClose = posts.some(({ modifiedAt }) => {
      return popupClosedAt.isBefore(modifiedAt);
   });
   if (foundPostModifiedAfterLastClose) return true;
   return false;
};

// Popup will show popup/modal with the content taken from WordPress, so the user must be signed in.
const Popup = () => {
   const [slider, setSlider] = useState();
   const [current, setCurrent] = useState(0);
   const [posts, setPosts] = useState([]);
   const [closedByUser, setClosedByUser] = useState(false);
   const show = shouldShow(closedByUser, posts);
   useEffect(() => {
      axios
         .get(`/wp/v2/posts`, {
            params: {
               per_page: 5,
               // TODO TRANSLATION: change category for english translation
               categories: 4006, // Pop up
               _embed: true,
               orderby: 'modified'
            }
         })
         .then(({ data }) => {
            const postsList = data.map(({ id, title, content, modified }) => {
               return {
                  id,
                  title: title.rendered,
                  content: content.rendered,
                  modifiedAt: modified
               };
            });
            setPosts(postsList);
         });
   }, [show]);
   const close = () => {
      Cookies.set(cookiesKey, dayjs());
      setClosedByUser(true);
   };
   if (!show) return null;
   const rendered = posts.map(({ id, title, content }) => {
      return (
         <div key={id}>
            <h1>{title}</h1>
            <PostContent>{parseContent(content || '', { trim: true })}</PostContent>
         </div>
      );
   });
   return (
      <Container className="modal" tabIndex={-1}>
         <Inner className="modal-dialog modal-xl">
            <div className="modal-content">
               <div className="modal-body">
                  <Slider
                     ref={(s) => setSlider(s)}
                     initialSlide={0}
                     arrows={false}
                     afterChange={() =>
                        setCurrent((prev) => {
                           return prev === posts.length - 1 ? 0 : prev + 1;
                        })
                     }
                  >
                     {rendered}
                  </Slider>
               </div>
               <Footer className="modal-footer" center={posts.length > 1}>
                  {posts.length > 1 && slider && (
                     <ChaneSlideContainer>
                        <ChangeSlideButton type="button" className="btn" onClick={slider.slickPrev}>
                           <img src={slidePrev} alt="" />
                        </ChangeSlideButton>
                        <ChaneSlideCurrent>
                           <span>{current + 1}</span>
                           <span>/</span>
                           <span>{posts.length}</span>
                        </ChaneSlideCurrent>
                        <ChangeSlideButton type="button" className="btn" onClick={slider.slickNext}>
                           <img src={slideNext} alt="" />
                        </ChangeSlideButton>
                     </ChaneSlideContainer>
                  )}
                  <Button onClick={close}>Zamknij</Button>
               </Footer>
            </div>
         </Inner>
      </Container>
   );
};

const Container = styled.div`
   display: block;
   background: rgba(0, 0, 0, 0.8);
`;

const Inner = styled.div`
   margin-top: 4.4rem;
   ${devices.mobileL} {
      margin-top: 4rem;
   }
`;

const ChaneSlideContainer = styled.div`
   display: flex;
   align-items: center;
`;

const ChaneSlideCurrent = styled.div`
   margin: 0 1rem;
   span {
      margin: 0 0.25rem;
   }
`;

const ChangeSlideButton = styled.button`
   line-height: 1;
   padding: 0;
   font-size: 2.5rem;
   &:focus {
      box-shadow: none;
   }
   img {
      width: 40px;
      height: 40px;
   }
`;

const PostContent = styled.div`
   white-space: pre-line;
   img {
      max-width: 100%;
      height: auto;
   }
`;

const Footer = styled.div`
   display: flex;
   justify-content: ${(props) => (props.center ? 'space-between' : 'flex-end')};
`;

export default Popup;
